import type { Container } from 'pixi.js';
import { OutOfLivesPopup } from '../game/views/popups/failFlow/OutOfLivesPopup';
import type {
  OutOfLivesPopupData,
  OutOfLivesPopupEvent,
  OutOfLivesEntryPoint,
} from '../game/views/popups/failFlow/OutOfLivesPopup';
import type { App } from '../app/App';
import { setContainerParent } from '../utils/pixi/transform-utils';

interface OpenOutOfLivesPopupConfig {
  app: App;
  entryPoint: OutOfLivesEntryPoint;
  viewsToMoveAbove?: Container[];
}

export function openOutOfLivesPopup(config: OpenOutOfLivesPopupConfig): Promise<void> {
  return new Promise<void>((resolve) => {
    const {
      app: {
        controller: { popups, overlay },
      },
      entryPoint,
      viewsToMoveAbove,
    } = config;

    const originalParents = viewsToMoveAbove?.map(({ parent }) => parent) ?? null;
    viewsToMoveAbove?.forEach((container) => {
      setContainerParent(container, overlay.view);
    });

    void popups.addPopup({
      popupConstructor: OutOfLivesPopup,
      data: {
        showLivesPopup: () => popups.closeActivePopup(false),
        entryPoint,
      } as OutOfLivesPopupData,
      onEvent: async (event: string) => {
        const livesPopupEvent = event as OutOfLivesPopupEvent;
        if (
          livesPopupEvent === 'exit' ||
          ((entryPoint === 'main-menu-play-button' || entryPoint === 'fail-popup') &&
            livesPopupEvent === 'lives-refilled')
        ) {
          await popups.closeActivePopup(false);
          resolve();
        }
      },
      onClosed: () => {
        viewsToMoveAbove?.forEach((container, index) => {
          if (!originalParents) return;
          const originalParent = originalParents[index];
          if (!originalParent) return;
          setContainerParent(container, originalParent);
        });
      },
    });
  });
}
